import React, { useContext } from "react";
import { ModalContainer } from "../styled";
import { DateFilterContext } from "../context";
import OptionsHeader from "./OptionsHeader";
import OptionsLayersSelection from "./OptionsLayersSelection";
import OptionsBottom from "./OptionsBottom";

export default () => {
  const { setSettingVisibility } = useContext(DateFilterContext);

  return (
    <ModalContainer
      isOpen
      minHeight="48rem"
      maxWidth="60rem"
      onCloseRequest={() => {
        setSettingVisibility(false);
      }}
    >
      <OptionsHeader />
      <OptionsLayersSelection />
      <OptionsBottom />
    </ModalContainer>
  );
};
